import { useState } from 'react';

const Link = ({ link }) => {

    return (
        <aside className="block col-1">
      <h2>Toimitustiedot</h2>
      <div>
          <div className="line">
            <div className="col-2">
                <h3> Etunimi </h3>
                {link.FirstName.length === 0 && 
                    <div>{
                    <p>
                        Nimi tarvitaan
                    </p>}
                    </div>}
                {link.FirstName}
            </div>

            <div className="col-2">
                <h3> Sukunimi </h3>
                {link.LastName.length === 0 && 
                    <div>{
                        <p>
                            Sukunimi tarvitaan
                        </p>
                    }</div>}
                {link.LastName}
            </div>
            <div className="col-2">
                <h3> Osoite </h3>
                {link.Address.length === 0 && 
                    <div>{
                        <p>
                            Osoite tarvitaan
                        </p>
                    }</div>}
                {link.Address}
            </div>
            <div className="col-2">
                <h3> Postinumero </h3>
                {link.PostalCode.length === 0 && 
                    <div>{
                        <p>
                            Postinumero tarvitaan
                        </p>
                    }</div>}
                {link.PostalCode}
                
            </div>
            <br></br>
            <p>
                <a class="button" href="/" onClick={() => {alert('Ostos on vahvistettu!')}}>vahvista ostos</a>
            </p>
            {link.PostalCode, link.Address, link.FirstName, link.LastName.length === 0 && 
                    <div>{
                     
                    }</div>}     
                   
          </div>
      </div>
    </aside>  
    )
}

const LinkForm = ({submitHandler}) => {
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [Address, setAddress] = useState("");
    const [PostalCode, setPostalCode] = useState("");
    return (
        <form onSubmit={e=>{submitHandler(e, {
            FirstName: FirstName,
            LastName: LastName,
            Address: Address,
            PostalCode: PostalCode
            });
            setFirstName("");
            setLastName("");
            setAddress("");
            setPostalCode("");
            }}>
            <div>
                <label>Etunimi</label>
                <input class="row" name="FirstName" required value={FirstName} onChange={e=>setFirstName(e.target.value)} type="text" id="FirstName"></input>
            </div>

            <div>
                <label>Sukunimi</label>
                <input class="row" name="LastName" required value={LastName} onChange={e=>setLastName(e.target.value)} type="text" id="LastName"></input>
            </div>

            <div>
                <label>Osoite</label>
                
                <input class="row" name="Address" required value={Address} onChange={e=>setAddress(e.target.value)} type="text" id="Address"></input>
            </div>

            <div>
                <label>Postinumero</label>
                <input class="row" name="PostalCode" required value={PostalCode} onChange={e=>setPostalCode(e.target.value)} type="text" id="PostalCode"></input>
            </div>
            <input type="submit"/>
        </form>
    )
}

const Links = ({links, setLinks}) => {
    const submitHandler = (e, newLink)=> {
        e.preventDefault();
        setLinks(links.concat(newLink));
    }
    
   
    return(
        <div>
            <LinkForm submitHandler =  {submitHandler}/>
                {links.map(l => <Link key={l.id} link={l}/>)}
                
        </div>
    )
}

export default Links;
